module.exports = __webpack_public_path__ + "static/img/new_01.31ee4c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/new_01.jpg
// module id = 0vgF
// module chunks = 0